module.exports = __webpack_public_path__ + "static/media/fangan.9c789cbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageLargeModelSecurity/fangan.png
// module id = 617
// module chunks = 0